import clsx from 'clsx';
import { CheckSquare } from 'lucide-react';

type Props = {
  title?: string;
  selectedCount: number;
  allSelectableCount: number;
  className?: string;
};

const HeaderBar: React.FC<Props> = ({ title, className }) => {
  return (
    <div
      className={clsx(
        'flex items-center gap-3 border-b border-stroke bg-gray-50 px-5 py-4 dark:border-strokedark dark:bg-boxdark',
        className
      )}
    >
      <div className="flex h-9 w-9 items-center justify-center rounded-full bg-primary/10">
        <CheckSquare className="h-5 w-5 text-primary" />
      </div>

      {title && (
        <h3 className="text-base font-semibold text-gray-900 dark:text-white">
          {title}
        </h3>
      )}
    </div>
  );
};

export default HeaderBar;
